export namespace RegexpConstants {
    export const floatRegexp: RegExp = /^(\d*\.?\d+){2,7}$/;
    export const intRegexp: RegExp = /^\d{1,3}$/;
    export const intRegexpBig: RegExp = /\d{2,7}/;
    export const menstrualRegexp: RegExp = /^\d{0,2}$/;
    export const nameRegexp: RegExp = /[^0-9\s.,_!¡?÷?¿/\\+=@#$%ˆ&*(){}|~<>;:[\]]+/;
    export const dateRegexp: RegExp = /\d{1,2}\.\d{1,2}\.\d{4}/;
    export const emailRegexp: RegExp = /[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}/;
}